module.exports = __webpack_public_path__ + "img/3.4fed4548.svg";